module.exports = __webpack_public_path__ + "img/img-check-index.8bee426e.png";